module.exports = __webpack_public_path__ + "img/BB.75c27448.png";